import React, { useState } from 'react';
import { Card } from 'antd';
import { CDBIcon } from 'cdbreact';

const TransactionSummaryCards = ({
    monthlyTotal,
    averageTicket,
    dailyTotalSales,
    summaryLoading,
    dailySummaryLoading,
    fechaFromMonthlySummary,
    fechaToMonthlySummary,
    fechaFromDailySummary,
    fechaToDailySummary
}) => {
    const [showMesActual, setShowMesActual] = useState(false);
    const [showPromedio, setShowPromedio] = useState(false);
    const [showDailySales, setShowDailySales] = useState(false);

    const formatCurrency = (amount) => {
        return new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "USD",
        }).format(amount || 0);
    };

    const cardStyle = (show) => ({
        width: 500,
        background: show ? '#D9FFD5' : '#9A9A9A',
        color: show ? '#3E3E3E' : '#FFFFFF',
        border: show ? '1px solid #0E9600' : '1px solid #9A9A9A',
        position: 'relative',
        transition: 'background-color 0.3s, border-color 0.3s',
        fontFamily: 'Montserrat, sans-serif'
    });

    const eyeStyle = {
        cursor: 'pointer',
        position: 'absolute',
        top: '10px',
        right: '10px'
    };

    return (
        <div style={{
            display: 'flex',
            flexDirection: 'row',
            flexWrap: 'wrap',
            width: '100%',
            gap: '50px',
            paddingLeft: '30px',
        }}>
            {/* Mes Actual */}
            <Card style={cardStyle(showMesActual)}>
                <div style={eyeStyle} onClick={() => setShowMesActual(!showMesActual)}>
                    {showMesActual ? <CDBIcon icon="eye" /> : <CDBIcon icon="eye-slash" />}
                </div>
                <div style={{ marginTop: '10px' }}>
                    <p style={{ textAlign: 'left' }} className="fw-bold h4">
                        {!summaryLoading && showMesActual ? formatCurrency(monthlyTotal) : '******'}
                    </p>
                </div>
                <p style={{ textAlign: 'left' }} className="fw-bold h5">Mes actual</p>
                {fechaFromMonthlySummary && fechaToMonthlySummary && showMesActual && (
                    <p style={{ textAlign: 'left', fontSize: '12px', color: showMesActual ? '#3E3E3E' : '#FFFFFF' }}>
                        Nota: Fecha estimada {fechaFromMonthlySummary} - {fechaToMonthlySummary}
                    </p>
                )}
            </Card>

            {/* Ticket Promedio */}
            <Card style={cardStyle(showPromedio)}>
                <div style={eyeStyle} onClick={() => setShowPromedio(!showPromedio)}>
                    {showPromedio ? <CDBIcon icon="eye" /> : <CDBIcon icon="eye-slash" />}
                </div>
                <div style={{ marginTop: '10px' }}>
                    <p style={{ textAlign: 'left' }} className="fw-bold h4">
                        {!summaryLoading && showPromedio ? formatCurrency(averageTicket) : '******'}
                    </p>
                </div>
                <p style={{ textAlign: 'left' }} className="fw-bold h5">Ticket promedio</p>
            </Card>

            {/* Ventas del Día */}
            <Card style={cardStyle(showDailySales)}>
                <div style={eyeStyle} onClick={() => setShowDailySales(!showDailySales)}>
                    {showDailySales ? <CDBIcon icon="eye" /> : <CDBIcon icon="eye-slash" />}
                </div>
                <div style={{ marginTop: '10px' }}>
                    <p style={{ textAlign: 'left' }} className="fw-bold h4">
                        {!dailySummaryLoading && showDailySales ? formatCurrency(dailyTotalSales) : '******'}
                    </p>
                </div>
                <p style={{ textAlign: 'left' }} className="fw-bold h5">Transacciones del día</p>
                {fechaFromDailySummary && fechaToDailySummary && showDailySales && (
                    <p style={{ textAlign: 'left', fontSize: '12px', color: showDailySales ? '#3E3E3E' : '#FFFFFF' }}>
                        Nota: Fecha estimada {fechaFromDailySummary} - {fechaToDailySummary}
                    </p>
                )}
            </Card>
        </div>
    );
};

export default TransactionSummaryCards;
